function sizeHeader(){
	var widthW =  screen.width;
	var tablet = 1500;
	var movil = 600;
  	var HeaderWindow = screen.height;
  	var Herohero = HeaderWindow * 0.60;
//   	var SectionHeader = $('#shopify-section-header').css('height');
	if(widthW < tablet && widthW > movil){
    $('#Hero-hero').css('height', HeaderWindow * 0.60); /* entre 600 y 1500 */
//    $('.p_destacada').css('height', HeaderWindow * 0.40);
    
    
	}else if(widthW > tablet){
   	$('#Hero-hero').css('height', HeaderWindow * 0.60); /* mayores a 1500  */
//    $('.p_destacada').css('height', HeaderWindow * 0.40);
	}else if(widthW < movil){
    	$('#Hero-hero').css('height', HeaderWindow * 0.60); /* movil */
//     	$('.p_destacada').css('height', HeaderWindow * 0.30);
	}
  	$('.hero__link').css('height', Herohero - 70); 
}

	

$(document).ready(function() {

  /* product slides */
  $('.owl-carousel').owlCarousel({
      loop:true,
      autoplay:false,
      nav:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  });
 
  sizeHeader();
  
  var count_li = $('.product-single__thumbnails li').length;

  if (count_li < 6) {
  	$('.product-single__thumbnails li').css('width', '80%');
    $('.product-single__thumbnails').css('justify-content', 'center');
  }

  
  
  $('#open-details').click(function(){

    $('.product_details').slideToggle('fast');

    $(this).toggleClass('active'); return false;
  });



  $('.site-header__menu').click(function(){
    $('.show-menu').slideToggle('fast');
    $('.show-menu').toggleClass('active');
    $('.site-header').toggleClass('active');
    $('#shopify-section-product-template').toggleClass('active');
    $('.template-page .main-content').toggleClass('active');
    $('#shopify-section-cart-template').toggleClass('active');
    $('#shopify-section-collection-template').toggleClass('active');  
    
    $(this).toggleClass('active'); return false;
     
  });

  thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
      if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
           optionValue = variantImages[strNewImage]['option-'+i];
           if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
             $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
           }
        });
      }
    });
  }
  
});

$(window).resize(function() {
	sizeHeader()
});

// $(window).scroll(function() {

//   var scroll = $(window).scrollTop();

//   if( scroll > 200 ) {
//     $('.site-header').addClass('sticky');
//   } else {
//     $('.site-header').removeClass('sticky');
//   } 
// });


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}